export const GoogleAPIKey = 'AIzaSyA1Xo-bDgo3segKgvXXmvin79XiASGDCh0';